/* pdp-limiter-force.js
   Brute-force PDP minimum quantity
   - Forces qty to minimum (e.g., 5)
   - Removes badge/notice UI
   - Disables ATC until minimum is reached
*/

(function () {
  const MIN_MAP = window.DATE_BASED_QTY_LIMITS || {};
  const RESTRICTED_DATES = window.RESTRICTED_DATES || [];

  const toInt = v => {
    const n = parseInt(v, 10);
    return Number.isNaN(n) ? 0 : n;
  };

  async function fetchCart() {
    try { return await fetch("/cart.js", { cache: "no-store" }).then(r=>r.json()); }
    catch { return null; }
  }

  async function getZapietDate() {
    const cart = await fetchCart();
    return cart?.attributes?.["Delivery-Date"] || null;
  }

  async function getExistingQty(variantId) {
    const cart = await fetchCart();
    if (!cart) return 0;
    const item = cart.items.find(i => Number(i.variant_id) === Number(variantId));
    return item ? Number(item.quantity) : 0;
  }

  // PDP logic
  async function initPDP() {
    const form = document.querySelector("form[action='/cart/add']");
    if (!form) return;

    const qtyInput = form.querySelector("input[name='quantity']");
    const atcBtn = form.querySelector(".t4s-product-form__submit, button[type='submit']");
    const variantInput = form.querySelector("[name='id']");

    if (!qtyInput || !atcBtn || !variantInput) return;

    const style = document.createElement("style");
    style.innerHTML = `
      .disabled-atc {
        pointer-events: none !important;
        opacity: .4 !important;
      }
    `;
    document.head.appendChild(style);

    function disableATC() {
      atcBtn.disabled = true;
      atcBtn.classList.add("disabled-atc");
    }
    function enableATC() {
      atcBtn.disabled = false;
      atcBtn.classList.remove("disabled-atc");
    }

    async function enforce() {
      const variantId = Number(variantInput.value);

      // find minimum rule
      const min = MIN_MAP[variantId];
      if (!min) {
        enableATC();
        return;
      }

      // check restricted date
      const zapDate = await getZapietDate();
      if (RESTRICTED_DATES.length && !RESTRICTED_DATES.includes(zapDate)) {
        enableATC();
        return;
      }

      const existing = await getExistingQty(variantId);
      let pdpQty = toInt(qtyInput.value);

      const total = pdpQty + existing;

      // FORCE NEW QTY TO MINIMUM
      if (total < min) {
        const needed = Math.max(min - existing, min);
        qtyInput.value = needed;
        disableATC();
        return;
      }

      // valid → allow ATC
      enableATC();
    }

    // lock the ATC on click if invalid
    atcBtn.addEventListener("click", async (e) => {
      await enforce();
      if (atcBtn.disabled) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);

    qtyInput.addEventListener("input", () => setTimeout(enforce, 40));

    const plus = form.querySelector("[data-increase-qty], [data-plus-qty]");
    const minus = form.querySelector("[data-decrease-qty], [data-minus-qty]");

    if (plus) plus.addEventListener("click", () => setTimeout(enforce, 60));
    if (minus) minus.addEventListener("click", () => setTimeout(enforce, 60));

    form.addEventListener("change", () => setTimeout(enforce, 80));

    // first run + continuous checks
    setTimeout(enforce, 200);
    setInterval(enforce, 400);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPDP);
  } else {
    initPDP();
  }
})();
